/**
 * @title membership.js: Feature level module
 * @description This is entry point for the application page.
 */
define(['application','quickApplication','quickMembershipCheckout'], function(application,QuickApplication,QuickMembershipCheckout) {
	/**
	 * Initializing the membership related functionality including
	 * 	1. Membership Application
	 * 	2. Quick Membership Checkout
	 * @return {void}
	 */
  function init() {
		//application.init();
		
		let page = $('[data-page]').data('page') || '';
		
		switch (page) {
		
		case 'quick-membership':
			QuickApplication.init();
		    break;
		    
		case 'quick-membership-purchase':
			QuickMembershipCheckout.init(page);
		    break;
		    
		case 'quick-membership-renew':
			QuickMembershipCheckout.init(page);
			break;
		   
		default: 
			application.init();
		}
		
	}
  if (typeof window.COSTCO == 'undefined') {
    window.COSTCO = {};
  }
  if (typeof window.COSTCO.Global == 'undefined') {
    document.addEventListener('CostcoGlobalLoaded', init, false);
  } else {
    init();
  }
});



// WEBPACK FOOTER //
// ./js/membership/membership.js